import { ScoringScopeBadge } from "app/pages/sales-intelligence/common-components/scoring/ScoringScopeBadge/ScoringScopeBadge";
import type { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

import { PlaybookSummaryBadgeCard } from "./PlaybookSummaryBadgeCard";

type PlaybookSummaryScoreCriteriaProps = {
    scope?: ScoringConfigType;
    label: string;
};

export const PlaybookSummaryScoreCriteria = ({ scope, label }: PlaybookSummaryScoreCriteriaProps) => (
    <PlaybookSummaryBadgeCard
        label={label}
        dataAutomation="playbook-summary-score-criteria-card"
        badge={<ScoringScopeBadge scope={scope} />}
    />
);
